var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addCode" },
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.$t("generateGiftCode"),
            visible: _vm.dialogShow,
            modal: false,
            "close-on-click-modal": false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "is_special",
                    label: _vm.$t("isSpecialGiftPack")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: { placeholder: _vm.$t("pleaseChoose") },
                      on: { change: _vm.whetherNotChange },
                      model: {
                        value: _vm.paramsData.is_special,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_special", $$v)
                        },
                        expression: "paramsData.is_special"
                      }
                    },
                    _vm._l(_vm.whetherNot, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "code", label: "code" }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity ",
                    attrs: { placeholder: _vm.$t("specialCodePlaceholder") },
                    model: {
                      value: _vm.paramsData.code,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "code", $$v)
                      },
                      expression: "paramsData.code"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "num", label: _vm.$t("generateCount") }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity no-number",
                    attrs: {
                      type: "number",
                      placeholder: _vm.$t("pleaseInput")
                    },
                    model: {
                      value: _vm.paramsData.num,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "num", _vm._n($$v))
                      },
                      expression: "paramsData.num"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "reward_num", label: _vm.$t("claimableCount") }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity no-number",
                    attrs: {
                      type: "number",
                      placeholder: _vm.$t("pleaseInput")
                    },
                    model: {
                      value: _vm.paramsData.reward_num,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "reward_num", _vm._n($$v))
                      },
                      expression: "paramsData.reward_num"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "body_length",
                    label: _vm.$t("giftCodeLength")
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity no-number",
                    attrs: {
                      type: "number",
                      placeholder: _vm.$t("specialCodeLengthPlaceholder")
                    },
                    model: {
                      value: _vm.paramsData.body_length,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "body_length", _vm._n($$v))
                      },
                      expression: "paramsData.body_length"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "date", label: _vm.$t("claimableTime") }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "operationFrame-entity",
                    attrs: {
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "daterange",
                      "range-separator": _vm.$t("range"),
                      "start-placeholder": _vm.$t("startDate"),
                      "end-placeholder": _vm.$t("endDate")
                    },
                    on: { change: _vm.dataChange },
                    model: {
                      value: _vm.date,
                      callback: function($$v) {
                        _vm.date = $$v
                      },
                      expression: "date"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "expire_time", label: _vm.$t("expireTime") }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "operationFrame-entity",
                    attrs: {
                      "popper-class": "no-atTheMoment",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "datetime",
                      placeholder: _vm.$t("date")
                    },
                    on: { change: _vm.expireChange },
                    model: {
                      value: _vm.expire_time,
                      callback: function($$v) {
                        _vm.expire_time = $$v
                      },
                      expression: "expire_time"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addDomain }
                    },
                    [_vm._v(_vm._s(_vm.$t("addItem")) + " ")]
                  )
                ],
                1
              ),
              _vm._l(_vm.paramsData.item_list, function(domain, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "Dynamic",
                    staticStyle: { display: "flex" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "x-f " },
                      [
                        _vm.paramsData.item_list.length > 1
                          ? _c("el-button", {
                              staticStyle: { "margin-right": "20px" },
                              attrs: {
                                size: "mini",
                                type: "danger",
                                circle: "",
                                icon: "el-icon-delete"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removeDomain(domain)
                                }
                              }
                            })
                          : _vm._e(),
                        _c("el-switch", {
                          staticStyle: { "margin-right": "20px" },
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                            "active-text": _vm.$t("permanent"),
                            "inactive-text": _vm.$t("valid")
                          },
                          model: {
                            value: domain.ispermanent,
                            callback: function($$v) {
                              _vm.$set(domain, "ispermanent", $$v)
                            },
                            expression: "domain.ispermanent"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem",
                            staticStyle: {
                              width: "150px",
                              "margin-right": "20px"
                            },
                            attrs: {
                              prop: "item_list." + index + ".item_id",
                              rules: _vm.rules.item_id
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  placeholder: _vm.$t("item")
                                },
                                model: {
                                  value: domain.item_id,
                                  callback: function($$v) {
                                    _vm.$set(domain, "item_id", $$v)
                                  },
                                  expression: "domain.item_id"
                                }
                              },
                              _vm._l(_vm.articleList, function(items, indexs) {
                                return _c("el-option", {
                                  key: indexs,
                                  attrs: { label: items.kind, value: items.id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem",
                            staticStyle: {
                              width: "200px !important",
                              "margin-right": "20px"
                            },
                            attrs: {
                              prop: "item_list." + index + ".expire",
                              rules: domain.ispermanent
                                ? null
                                : _vm.rules.expire_time
                            }
                          },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                "popper-class": "no-atTheMoment",
                                disabled: domain.ispermanent,
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                type: "datetime",
                                placeholder: _vm.$t("date")
                              },
                              model: {
                                value: domain.expire,
                                callback: function($$v) {
                                  _vm.$set(domain, "expire", $$v)
                                },
                                expression: "domain.expire"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem",
                            staticStyle: { width: "100px" },
                            attrs: {
                              prop: "item_list." + index + ".num",
                              rules: _vm.rules.item_num
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: _vm.$t("quantity") },
                              model: {
                                value: domain.num,
                                callback: function($$v) {
                                  _vm.$set(domain, "num", $$v)
                                },
                                expression: "domain.num"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              })
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }